import { render } from "./RbiEdit.vue?vue&type=template&id=aee8c80a&scoped=true"
import script from "./RbiEdit.vue?vue&type=script&lang=js"
export * from "./RbiEdit.vue?vue&type=script&lang=js"

import "./RbiEdit.vue?vue&type=style&index=0&id=aee8c80a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aee8c80a"

export default script